import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';

/** Days to subtract so the window has 7 calendar days including today. */
export const LAST_SEVEN_DAYS_OFFSET = 6;
export const LAST_SEVEN_DAYS_COUNT = LAST_SEVEN_DAYS_OFFSET + 1;

export function getLastSevenDaysPeriod() {
  return {
    start: subDays(startOfDay(new Date()), LAST_SEVEN_DAYS_OFFSET),
    end: new Date()
  };
}
